import { useRef } from 'react';
export function useLastTruthyValue(value) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var ref = useRef(value);
  if (value) {
    ref.current = value;
  }
  return ref.current;
}